import { api } from "./client.js";

export interface SecretStatus {
  name: string;
  label: string;
  source: "db" | "env" | "none";
  /** ISO-время последней правки в БД; null если секрет не из БД. */
  updatedAt: string | null;
}

export async function fetchSecretStatuses(): Promise<SecretStatus[]> {
  const r = await api<{ secrets: SecretStatus[] }>("/api/integrations/secrets");
  return r.secrets;
}

/** Сохранить токен. Значение наружу не возвращается. */
export async function saveSecret(name: string, value: string): Promise<void> {
  await api("/api/integrations/secrets", {
    method: "POST",
    body: JSON.stringify({ name, value }),
  });
}
